import styled from '@emotion/styled';
import { COLORS } from '../../../../../constants/radar';

export const DashboardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  padding: 24px;
`;

export const DashboardCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  height: 200px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const DashboardCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DashboardName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DashboardDescription = styled.div`
  font-size: 14px;
  color: #666;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
